<template>
	<ul class="site-submenu">
		<li
			v-for="(menu, index) in menus"
			:key="index"
			class="site-submenu__item"
			:title="menu.title"
		>
			<router-link
				:to="{
					path: menu.path
				}"
				exact-active-class="is-active"
				class="site-submenu__link"
				@click.native="clickHandler"
				>{{ menu.text }}</router-link
			>
		</li>
	</ul>
</template>

<script>
export default {
	name: 'SiteSubMenu',
	props: {
		/* [{text: '', path: '', title: '', permission: ''}]  */
		menus: {
			type: Array,
			default: () => []
		}
	},
	methods: {
		clickHandler() {
			this.$emit('show', false);
		}
	}
};
</script>

<style lang="scss" scoped>
/**
    * Site Sub-Menu
    * Can use SCSS variables = TRUE
 */
.site-submenu {
	opacity: 0;
	max-height: 0;
	overflow: hidden;
	background-color: $white;
	@include text-contrast($white, $white, $black);
	z-index: 2;

	@include mq($from: lg) {
		min-width: 140px;
		position: absolute;
		width: auto;
		border-radius: $submenu-border-radius;
		box-shadow: $submenu-shadow;
		font-size: $submenu-font-size;
	}

	&__item {
		&:first-child {
			margin-top: $gutter-md;
		}
		&:last-child {
			margin-bottom: $gutter-md;
		}
		@include mq($until: lg) {
			text-indent: $padding-sm;
		}
	}

	&__link {
		display: block;
		padding: $padding-sm;

		&:focus,
		&:hover {
			background: lighten($neutral-4, 5%);
			@include text-contrast(lighten($neutral-4, 5%), $white, $black);
		}

		&.is-active,
		&:active {
			background: $neutral-4;
			@include text-contrast($neutral-4, $white, $black);
		}
	}
}
</style>
